/* eslint-disable react/jsx-props-no-spreading */

import React, { InputHTMLAttributes } from 'react';
import AutocompleteInputWrapper from './styles';

interface AutocompleteInputProps extends InputHTMLAttributes<HTMLInputElement> {
	label?: string;
	errorMessage?: string;
	customErrorMessage?: string;
	tag?: string;
	onBlur?: (data: any) => void;
	fireValidationOnBlur?: () => void;
	setValue: (val: any) => void;
	direction?: 'rtl' | 'ltr';
	options?: any;
}

const AutocompleteInput: React.FC<AutocompleteInputProps> = ({
	label,
	errorMessage,
	customErrorMessage,
	tag,
	onBlur,
	fireValidationOnBlur,
	setValue,
	direction = 'rtl',
	...rest
}) => {
	const handleSetAutocompleteTag = () => {
		setValue(tag);
	};

	return (
		<AutocompleteInputWrapper
			className='input'
			$hasError={!!errorMessage || !!customErrorMessage}
			$direction={direction}
		>
			{label && rest.id && (
				<label className='label' htmlFor={rest.id}>
					{label}
				</label>
			)}
			{tag && tag.length > 0 && (
				<button
					type='button'
					id='autocomplete-tag'
					onClick={handleSetAutocompleteTag}
				>
					{tag}
				</button>
			)}
			<input
				{...rest}
				onBlur={(event: any) => {
					if (onBlur) {
						onBlur(event);
					}
					if (fireValidationOnBlur) {
						fireValidationOnBlur();
					}
				}}
			/>
			{(!!errorMessage || !!customErrorMessage) && (
				<span className='error-message'>
					{errorMessage || customErrorMessage}
				</span>
			)}
		</AutocompleteInputWrapper>
	);
};

AutocompleteInput.defaultProps = {
	label: '',
};

export default AutocompleteInput;
